module.exports = __webpack_public_path__ + "img/img.6484e3da.jpg";